import { render, staticRenderFns } from "./question-builder.vue?vue&type=template&id=6d8a6e9f"
import script from "./question-builder.vue?vue&type=script&lang=js"
export * from "./question-builder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports